/*
 * @Description: 绩效管理
 * @Author: 杨志航<yangzhihang@372163.com>
 * @Date: 2021-11-05 14:07:34
 */

const ach = {
  // 绩效目标与结果
  getAchResultList: {
    url: '/fortune/achievements/getAchResultList',
    method: 'get'
  },
  getSearchData: {
    url: '/fortune/achievements/getSearchData',
    method: 'get'
  },
  updateAchResult: {
    url: '/fortune/achievements/updateAchResult',
    method: 'post'
  },
  delAchResult: {
    url: '/fortune/achievements/delAchResult',
    method: 'post'
  },
  signAchResult: {
    url: '/fortune/achievements/signAchResult',
    method: 'post'
  },
  uploadAchResultFile: {
    url: '/fortune/achievements/upload',
    method: 'post'
  },
  getMonthList: {
    url: '/fortune/achievements/getMonthList',
    method: 'get'
  },
  copyAchTargetVerify: {
    url: '/fortune/achievements/copyAchTargetVerify',
    method: 'get'
  },
  copyAchTarget: {
    url: '/fortune/achievements/copyAchTarget',
    method: 'get'
  },
  // 年度目标管理
  getYearList: {
    url: '/fortune/achievements/getYearList',
    method: 'get'
  },
  saveAchYear: {
    url: '/fortune/achievements/saveAchYear',
    method: 'post'
  },
  getStfList: {
    url: '/fortune/achievements/getStfList',
    method: 'get'
  },
  delYear: {
    url: '/fortune/achievements/delYear',
    method: 'post'
  },
  // 绩效审批
  getAddStaffList: {
    url: '/fortune/achievements/getAddStaffList',
    method: 'get'
  },
  getAchievementsStaffList: {
    url: '/fortune/achievements/getStaffList',
    method: 'get'
  },
  updateStaffAuditNode: {
    url: '/fortune/achievements/updateStaffAuditNode',
    method: 'post'
  },
  addAchievementsStaff: {
    url: '/fortune/achievements/addStaff',
    method: 'post'
  },
  delAchievementsStaff: {
    url: '/fortune/achievements/delStaff',
    method: 'post'
  },
  applyApprovalTarget: {
    url: '/fortune/achAudit/applyApproval',
    method: 'post'
  },
  getApprovalList: {
    url: '/fortune/achAudit/getApprovalList',
    method: 'get'
  },
  delAchAudit: {
    url: '/fortune/achAudit/del',
    method: 'post'
  },
  getApprovalDetail: {
    url: '/fortune/achAudit/getApprovalDetail',
    method: 'get'
  },
  submitAchAudit: {
    url: '/fortune/achAudit/audit',
    method: 'post'
  },
  // 运营人员管理
  getAchOperationList: {
    url: '/CheckInStat/GetOperationList',
    method: 'get'
  },
  delAchOperation: {
    url: '/CheckInStat/DelOperation',
    method: 'post'
  },
  getAchOperationSearchList: {
    url: '/CheckInStat/GetOperationSearchList',
    method: 'get'
  },
  getAchImportOperation: {
    url: '/CheckInStat/ImportOperation',
    method: 'post'
  },
}

export default ach
